import classNames from 'classnames'
import { Pill } from '../Pill'
import styles from './styles.module.scss'

const BetaBadgePill = ({ className }: { className?: string }) => {
  return <Pill className={classNames(className, styles.betaBadge)}>BETA</Pill>
}

export default BetaBadgePill
